import HeaderTitleWithBadgeView from "./HeaderTitleWithBadgeView";

/**
 * Container component for HeaderTitleWithBadge.
 * Passes through props to the view component.
 * @param props - Component props
 * @param props.title - The title text to display
 * @param props.headerTintColor - Color for the title text
 */
function HeaderTitleWithBadgeContainer({
  title,
  headerTintColor,
}: {
  title: string;
  headerTintColor: string;
}) {
  return (
    <HeaderTitleWithBadgeView title={title} headerTintColor={headerTintColor} />
  );
}

export default HeaderTitleWithBadgeContainer;
